export default __webpack_public_path__ + "static/media/rss3.e98ff675.PNG";